var $=jQuery;
jQuery(document).ready(function ($) {

  if ($('.product-single__gallery > li').length > 1) {
    $('.product-single__gallery').flickity({
          imagesLoaded: true,
          prevNextButtons: false,
          percentPosition: true, 
          pageDots: true,
          rightToLeft: false,
          autoPlay: false,
          sync: '.product-single__thumbnails'
      }); 
    
    $('.product-single__gallery').on('change.flickity', function(event, index) {
        var $thumbnails = $('.product-single__thumbnails li');
        $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
        $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
    });
    $('.product-single__thumbnails li').first().addClass('active');
    
    // Thumbnail click event to change the gallery image
    $('.product-single__thumbnails li').on('click', function() {
        var index = $(this).index();
        $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
    });
  }
  
});